export default {"src":"/_next/static/media/growth.ff166bc3.svg","height":399,"width":400};